import React from "react";
import LocationPage from "./LocationPage";

export default function WebdesignAgenturWolfsberg() {
  return <LocationPage locationKey="wolfsberg" />;
}
